
export class PriceHelper {
    static getBlockTvaFromBom(productBlockRow: any): number {
        let blockTva = productBlockRow.find(p => p.clientMetadata?.TVA != undefined);
        if (blockTva) {
          return blockTva.clientMetadata.TVA;
        } else {
          console.error("Aucun produit du groupe n'a de TVA");
          return undefined;
        }
    }

    static getUnitPriceHtFromBom(productRow: any, productBlockRow: any) {
        if (productRow.clientMetadata?.TVA) {
            return this.getPriceHtFromTTCAndVat(productRow.price.current.value, productRow.clientMetadata.TVA, true);
        }
    
        let blockTva = this.getBlockTvaFromBom(productBlockRow);
        return blockTva ? this.getPriceHtFromTTCAndVat(productRow.price.current.value, blockTva, true) : undefined;        
    }

    static getPriceHtFromBom(productRow: any, productBlockRow: any) {
        if (productRow.clientMetadata?.TVA) {
            return this.getPriceHtFromTTCAndVat(productRow.totalPrice, productRow.clientMetadata.TVA, true);
        }

        let blockTva = this.getBlockTvaFromBom(productBlockRow);
        return blockTva ? this.getPriceHtFromTTCAndVat(productRow.totalPrice, blockTva, true) : undefined;
    }

    static getBlockPriceHtFromBom(productBlock: any) {

        return productBlock.rows.reduce(
            (acc, val) => {
                let rowPriceHt = this.getPriceHtFromBom(val, productBlock.rows);
                if (rowPriceHt === undefined) {
                    return undefined;
                }

                return acc + this.getPriceHtFromBom(val, productBlock.rows)}, 0            
          );
    }

    static getPriceHtFromTTCAndVat(priceTtc: number, vat: number, percentage: boolean) {
        return priceTtc / (1 + vat / (percentage ? 100 : 1));
    }
}